import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { MainNavigationComponent } from "./components/main-navigation/main-navigation.component";
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MainNavigationComponent,
    NgbCollapse
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Taniti';
  isMainNavCollapsed: boolean = true;

  constructor(private titleService: Title, private metaService: Meta ) {
    this.titleService.setTitle(this.title);
    this.metaService.updateTag(
      {
        name: 'description',
        content: 'Changing meta tags using an Angular service'
      }
    );
  }
}
